import React, { forwardRef } from "react";
import HeadingSection from "../HeadingSection/HeadingSection";
import {
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
  FaFacebook,
} from "react-icons/fa6";
import { SiZillow } from "react-icons/si";

const iconMap = {
  FaFacebook: FaFacebook,
  FaLinkedinIn: FaLinkedinIn,
  FaXTwitter: FaXTwitter,
  FaInstagram: FaInstagram,
  SiZillow: SiZillow,
  // Add other icons you expect to use
};

const ShowAgent = forwardRef(({ title, tagline, dataTeam }, ref) => {
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  // console.log("Data Team:", dataTeam); // Debugging line to check dataTeam

  return (
    <section className="white-bg" id="team" ref={ref}>
      <div className="container">
        <div className="row">
          <HeadingSection title={title} tagline={tagline} />
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-sm-3 startup-member">
            {dataTeam.map((member, i) => (
              <div
                key={member.id}
                data-aos={"fade-up"}
                data-aos-delay={`${i}00`}
                data-aos-duration={700}
              >
                <div className="team-member-container">
                  <img
                    src={`${imageBaseUrl}/${member.image}`}
                    className="img-fluid"
                    alt="team-01"
                  />
                  <div className="member-caption">
                    <div className="member-description text-center">
                      <div className="member-description-wrap">
                        <ul className="member-icons">
                          {member.social.map((item) => (
                            <li className="social-icon h3 pr-10" key={item.id}>
                              <a
                                href={item.link}
                                className="social-icon icofont-2x"
                              >
                                {iconMap[item.icon]
                                  ? React.createElement(iconMap[item.icon])
                                  : null}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="white-bg pt-20 pb-20 box-shadow-hover text-center">
                  <h4 className="member-title text-uppercase">
                    CONTACT {member.name}
                  </h4>
                  Phone: {member.phone}
                  <br />
                  Cell: {member.cell}
                  <br />
                  Fax: {member.fax}
                  <br />
                  <a href={`mailto:${member.email}`}>{member.email}</a>
                </div>
              </div>
            ))}
          </div>

          <div className="col-sm-7">
            {dataTeam.map((member, i) => (
              <div
                key={i}
                data-aos={"fade-up"}
                data-aos-delay={`${i}00`}
                data-aos-duration={700}
              >
                <h4 className="member-title text-uppercase">{member.name}</h4>
                <p className="member-subtitle">{member.role}</p>
                <p
                  className="member-subtitle paras bio-text"
                  dangerouslySetInnerHTML={{ __html: member.bio }}
                ></p>
              </div>
            ))}
          </div>

          <div className="col-sm-2">
            <p>
              <span className="listinghed">
                <b>CURRENT LISTINGS:</b>
              </span>
              <br />
              <span className="listing">
                {dataTeam.map((member, i) =>
                  member.properties
                    .filter(
                      (item) => item.status === "A" || item.status === "C"
                    )
                    .map((item) => (
                      <React.Fragment key={item.webid}>
                        <a href={`/property/${item.webid}`}>{item.address}</a>
                        <br />
                      </React.Fragment>
                    ))
                )}
              </span>
              <br />
              <br />
              <span className="listinghed">
                <b>RECENTLY SOLD:</b>
              </span>
              <br />
              <span className="listing">
                {dataTeam.map((member, i) =>
                  member.properties
                    .filter((item) => item.status === "S")
                    .slice(0, 50)
                    .map((item) => (
                      <React.Fragment key={item.webid}>
                        <a href={`/property/${item.webid}`}>{item.address}</a>
                        <br />
                      </React.Fragment>
                    ))
                )}
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
});

export default ShowAgent;
